import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createPlanningEvent,
  deletePlanningEvent,
  getPlanningCalendar,
} from "../../services/planningService";

export const planningKeys = {
  all: ["planning"],
  calendar: (params) => ["planning", "calendar", params],
};

export function usePlanningCalendar(params, navigate, options = {}) {
  return useQuery({
    queryKey: planningKeys.calendar(params),
    queryFn: () => getPlanningCalendar(params, navigate),
    ...options,
  });
}

export function useCreatePlanningEvent(navigate) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createPlanningEvent(data, navigate),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: planningKeys.all }),
  });
}

export function useDeletePlanningEvent(navigate) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, partitionKey }) =>
      deletePlanningEvent(id, partitionKey, navigate),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: planningKeys.all }),
  });
}

